import modelBaseV2 from "../model-base-v2.model";

const FootTrafficModel = {
  downloadTemplate: () => {
    return modelBaseV2.postDownload(
      "/api/executesp/export/file",
      {
        body: {
          storedProcedureCode: "25",
          params: [],
          excelSheetNames: ["FootTraffic"],
        },
      },
      "Template_FootTraffic_Upload"
    );
  },

  searchFootTraffic: (queries = {}) => {
    return modelBaseV2.get("/api/FootTraffic/search/gridlist", {
      params: queries,
    });
  },

  uploadAndValidate: (formData) => {
    return modelBaseV2.post(
      "/api/FootTraffic/template/uploadvalidate",
      {
        body: formData,
      }
    );
  },

  downloadExcel: (body, fileName) => {
    return modelBaseV2.postDownload('/api/FootTraffic/exceldownload', { body }, fileName)
  },
  downloadSummaryExcel: (body, fileName) => {
    body.pageSize = -1;
    const paramsMapping = {
      pageIndex: "3",
      pageSize: "4",
      channel: "119",
      trafficFrom: "133",
      trafficTo: "134"
    }
    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let attr = body[key];
      return {
        code: value,
        value: attr
          ? Array.isArray(attr)
            ? attr.join('^')
            : attr.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "Foot Traffic Summary",
      ],
      storedProcedureCode: "67",
      params
    }
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: exportConfig }, fileName);
  },
};

export default FootTrafficModel;
